<template>
    <section class="get-started">
        <div class="container container--mw-xxl get-started__container">
            <div class="get-started__inner-wrap">
                <h2 class="get-started__heading">GET STARTED TODAY!</h2>

                <p class="get-started__copy">Use Khonsu’s platform to create, check and secure your new brand name</p>

                <FormulateInput type="text" v-model="projectName" placeholder=""
                    :outer-class="['get-started__input-wrapper']" :wrapper-class="['formulate-input-wrapper--inline']"
                    :element-class="['formulate-input-element--inline', 'formulate-input-element--inline-green']"
                    ref="getStartedInput">
                    <template #suffix>
                        <button type="button" class="btn" @click="save_brand_name">ENTER</button>
                    </template>
                </FormulateInput>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'GetStarted',
    data: function () {
        return {
            projectName: '',
            sentences: [
                "Funkwhack",
                "Snubbla",
                "Guazy",
                "Huggles",
                "Wagbag",
                "Dregskegs",
                "Cooltrain"
            ],
            currentSentence: 0,
            currentLetter: 0,
            typing: true,
            pause: 2000,
            loginstate: false,
            intervalID: ''
        }
    },
    mounted() {
        this.animateText();

        if (sessionStorage.getItem("_khonsu_user_login_status")) {
            this.loginstate = true;
        }
    },
    methods: {
        ...mapActions('BrandCentre', [
            'setProjectName',
        ]),
        save_brand_name() {
            this.setProjectName(this.projectName);

            this.projectName = '';

            if (this.loginstate) {
                this.$router.push('/brand-creator');
            } else {
                this.$router.push('/login');
            }
        },
        animateText() {
            let input = this.$refs.getStartedInput;

            input.$attrs.placeholder = "";

            this.intervalID = setInterval(() => {
                if (this.typing) {
                    this.currentLetter++;

                    if (this.currentLetter <= this.sentences[this.currentSentence].length) {
                        input.$attrs.placeholder = input.$attrs.placeholder + this.sentences[this.currentSentence][this.currentLetter - 1];
                    } else {
                        this.currentLetter = 0;
                        this.typing = false;

                        setTimeout(() => {
                            this.currentSentence++;

                            if (this.currentSentence >= this.sentences.length) {
                                this.currentSentence = 0;
                            }

                            input.$attrs.placeholder = "";
                            this.typing = true;
                        }, this.pause);
                    }
                }
            }, this.randDelay(50, 100));
        },
        randDelay(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        animationController() {
            if (this.projectName.length > 0) {
                clearInterval(this.intervalID);
            } else {
                this.currentLetter = 0;
                this.typing = true;
                this.animateText();
            }
        }
    }
}
</script>